let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1i2PA")).then(() => parcelRequire('ba1jU'));